/* Documents API — dispatches to the mock or the real HTTP backend. */
import { USE_MOCK_API } from './httpClient'
import * as mock from './documents.mock'
import * as http from './documents.http'

export type { AddDocumentInput } from './documents.mock'

const impl = USE_MOCK_API ? mock : http

export const listDocuments = impl.listDocuments
export const addDocument = impl.addDocument
export const deleteDocument = impl.deleteDocument
